import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import _ from 'lodash';
import ValidatorFormGroup from '../../main/validator-form-group';
import translate from '../../translate';

const MAX_LENGTH_ALLOWED_FOR_NOTE = 250;

const VALIDATORS = {
    note: {
        isValid: (value) => `${value}`.length <= MAX_LENGTH_ALLOWED_FOR_NOTE,
    },
};

const LocationNoteForm = createReactClass({
    displayName: 'LocationNoteForm',

    propTypes: {
        values: PropTypes.shape({
            note: PropTypes.string,
        }),
        handleChange: PropTypes.func.isRequired,
        forceValidation: PropTypes.bool,
        disabled: PropTypes.bool,
        forceDisable: PropTypes.bool,
        strings: PropTypes.shape({
            note: PropTypes.string,
        }).isRequired,
        selectedPartner: PropTypes.shape({}).isRequired,
    },

    defaultProps: {
        disabled: false,
        forceDisable: false,
        forceValidation: false,
    },

    getInitialState() {
        return _.extend(
            {
                note: '',
                _dirty: {},
                _valid: true,
            },
            this.props.values
        );
    },

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
            this.setState(nextProps.values, this._persistState);
        }
    },

    _persistState() {
        const new_state = {};
        _.each(['note'], (fieldName) => {
            new_state[fieldName] = this.state[fieldName];
        });
        // return valid state to parent
        new_state._valid = Object.keys(VALIDATORS).reduce(
            (formValid, fieldName) =>
                formValid &&
                VALIDATORS[fieldName].isValid(new_state[fieldName]),
            true
        );
        this.props.handleChange(new_state);
    },

    _markDirty(key) {
        const newDirt = {};
        newDirt[key] = true;
        const newState = _.extend({}, this.state, {
            _dirty: _.extend({}, this.state._dirty, newDirt),
        });
        this.setState(newState);
    },

    _handleFormChange(key, value) {
        this._markDirty(key);
        const newSt = _.set({}, key, value);
        newSt[key] = value;
        this.setState(newSt, this._persistState);
    },

    render() {
        return (
            <div>
                <ValidatorFormGroup
                    label={this.props.strings.note}
                    hideErrorLabel={
                        !(
                            this.state._dirty.note || this.props.forceValidation
                        ) || VALIDATORS.note.isValid(this.state.note)
                    }
                    errorLabel={this.props.strings.note_error}
                >
                    <textarea
                        value={this.state.note}
                        className="form-control"
                        name="note"
                        rows="6"
                        onChange={(event) => {
                            this._handleFormChange('note', event.target.value);
                        }}
                        disabled={this.props.disabled}
                    />
                </ValidatorFormGroup>
            </div>
        );
    },
});

export default translate('LocationCostsForm')(LocationNoteForm);
